import axios from "axios";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setDatiPagamentoGas, setInfoGas, setNotifiche, setPopupInfo, setRinnovoContrattuale, setSaldoGas } from "../features/gasSlice";
import { setSection } from "../features/settingSlice";
import { setCurrentPod } from "../features/userSlice";



export function useFetchLoginGas() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const customerGas = useSelector((user) => user?.gas?.info?.customer_code)
    const [state, setState] = useState()
    return async(pod, customerCodeGas) => {
        setState(pod.username)
        const fakeGasLogin = `https://my.revoluce.it/area_utente/gestione/api/login/fakeLoginGas.php?username=${pod.username}` ;
       await axios.get(fakeGasLogin).then(({ data }) => {
            console.log(data)
            let notifiche = []
            notifiche = [data.notificheRid, data.notificheToken]
            dispatch(setPopupInfo({flag_popup: data.flag_popup, titolo_popup: data.titolo_popup, body_popup: data.body_popup}))
            dispatch(setRinnovoContrattuale(data.body_nuovo_contratto))
            dispatch(setNotifiche(notifiche))
            dispatch(setSection(true))
            dispatch(setSaldoGas(data.saldo))
            const result = data.data.altri_dati_pod;
            dispatch(setInfoGas(data.data))
            dispatch(setDatiPagamentoGas(data.dati_pagamento))
            dispatch(setCurrentPod({podCode: result.pod_code, podName: result.name_extended, podAddress: result.pod_address}))
       })
    }
}

